import {
  Component,
  EventEmitter,
  Input,
  ViewChild,
  Renderer2,
  Output,
} from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { LoggerService } from 'src/app/services/logger.service';
import {
  PCTableInputModel,
  PCTableOutputModel,
} from '../../models/pc-table-input-model';
import { UserApiService } from '../../services/user-api.service';
import { ApiRequestModel } from 'src/app/models/api-request-model';
import { CustomizeResponseService } from '../../services/customize-response.service';
import { PCSearchRequestModel } from '../../models/pc-search-request-model';
import { TabelPaging } from '../../interfaces/table';
import {
  PCTableActionInputModel,
  PCTableFieldModel,
} from '../../models/pc-table-action-input-model';
import { Router } from '@angular/router';
import { forkJoin, of } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { PCTableComponent } from '../../components/pctable/pctable.component';
import { PcsettingModalComponent } from '../../components/pcsetting-modal/pcsetting-modal.component';

@Component({
  selector: 'app-cash-desk',
  templateUrl: './cash-desk.component.html',
  styleUrls: ['./cash-desk.component.css'],
})
export class CashDeskComponent {
  public item: any;
  public Value: any;
  public searchedItem: string;
  public cashDesk: any;

  @ViewChild(PCTableComponent) pcTableComponent!: PCTableComponent;
  @ViewChild(PcsettingModalComponent)
  pcsettingModalComponent!: PcsettingModalComponent;

  public constructor(
    private modalService: NgbModal,
    private renderer: Renderer2,
    private logger: LoggerService,
    private apiService: UserApiService,
    private responseService: CustomizeResponseService,
    private router: Router
  ) {
    this.editable = true;
    this.deleteable = true;
    this.searchedItem = '';
    this.requestModel = new PCSearchRequestModel();

    this.renderer.listen('window', 'keyup', (e: any) => {
      if (e.key == '+') {
        this.OpenClearModal();
      }
      if (e.key == 'c') {
        // this.confirmPayment(true);
      }
    });

    this.action = new PCTableActionInputModel(
      [
        {
          name: 'credit',
          className: 'btn-outline-primary',
          icon: 'fa-solid fa-credit-card',
        },
        {
          name: 'FastSale',
          className: 'btn-outline-primary',
          icon: 'fa-solid fas fa-smile',
        },
        {
          name: 'Reload',
          className: 'btn-outline-primary',
          icon: 'bx bx-refresh',
        },
        {
          name: 'Settings',
          className: 'btn-outline-primary',
          icon: 'bx bx-cog',
        },
        {
          name: 'Print',
          className: 'btn-outline-primary',
          icon: 'bx bx-printer',
        },
        {
          name: 'Explanation',
          className: 'btn-outline-primary',
          icon: 'bx bx-question-mark',
        },
      ],
      'CashDesk',
      []
    );

    if (this.endPoint != null) {
      this.action.title = this.endPoint;
    }
    this.generateUrl();

    forkJoin([this.getData(), this.getEntity()]).subscribe(
      ([dataResult, entityResult]) => {
        if (dataResult) {
          this.logger.addResponseLog(this.endPointUrl, dataResult, `Get All`);
          if (dataResult.succeeded) {
            let firstItemOnPage = dataResult.data?.firstItemOnPage || 1;

            if (dataResult.data?.pageCount! < dataResult.data?.pageNumber! && dataResult.data?.pageCount!=0) {
              this.requestModel.pageNumber = 1;
              this.getSingleData();
            }

            this.data = new PCTableInputModel(
              dataResult.data?.items,
              [
                {
                  name: 'Payment',
                  className: 'btn-outline-primary',
                  icon: 'fa-solid fa-credit-card',
                },
                {
                  name: 'Delete',
                  className: 'btn-outline-danger',
                  icon: 'bx bx-trash',
                },
              ],
              true,
              firstItemOnPage,
              this.requestModel.orderBy,
              this.requestModel.direction
            );

            this.paging = this.responseService.customizePaging(dataResult);
          }
        }

        if (entityResult) {
          this.logger.addResponseLog(
            this.endPoint == null ? '' : this.endPoint,
            entityResult,
            `Get Entity`
          );
          if (entityResult.succeeded) {
            let fields = this.apiService.convertStringToBoolean(
              entityResult.data.fields
            );

            fields.forEach((element) => {
              element.camelCaseName = this.apiService.camelCase(
                element.fieldName
              );
            });

            this.fields = fields;
          }
        }

        setTimeout(() => {
          if (this.pcTableComponent) {
            this.pcTableComponent.InitPage();
          } else {
            console.error('PCTableComponent not found');
          }
        }, 2);

        setTimeout(() => {
          let selectStockPage = document.getElementById('selectStockPage');
          if (selectStockPage) {
            selectStockPage.classList.remove('animate__backInDown');
          }
        }, 2000);

        this.loading = false;
      },
      (error) => {
        this.apiService.AddErrorLog(error);
        this.loading = false;
      }
    );
  }

  @Input() endPoint?: string;

  @Output() childEvent = new EventEmitter<PCTableOutputModel>();

  public paymentModalIsOpen: boolean = false;
  public endPointUrl: string = 'SaleFactor/CashDesk';
  public openAddModal: boolean = false;
  public data?: PCTableInputModel;
  public requestModel: PCSearchRequestModel;
  public loading: boolean = false;
  public thisItem: any;
  public customerPaid?: number;
  public action: PCTableActionInputModel;
  public fields: any[] = [];
  public searchField: any[] = [];
  public paging?: TabelPaging;
  public thisValue: any;
  public editable: boolean;
  public deleteable: boolean;
  public modalSuccessConfirm: boolean = false;
  public modalDeleteConfirm: boolean = false;
  public newBarcodLoading: boolean = false;

  public factorList: any[] = [];
  public finalPayment: number = 0;
  public scannedBarcode: string = ``;
  public scannerLog: string = ``;
  public scannerCompleted: boolean = false;

  @ViewChild('credit') creditElemnt: any;
  @ViewChild('modalContent') modalContent!: any;

  public getSingleData() {
    try {
      this.generateUrl();
      if (
        !this.apiService.tokenValidation(new ApiRequestModel(this.endPointUrl))
      ) {
        return;
      }

      this.apiService.getAll(new ApiRequestModel(this.endPointUrl)).subscribe(
        (result) => {
          this.logger.addResponseLog(this.endPointUrl, result, `Get All`);
          if (result.succeeded) {
            let firstItemOnPage = 1;
            if (result.data?.firstItemOnPage) {
              firstItemOnPage = result.data?.firstItemOnPage;
            }

            if (result.data?.pageCount! < result.data?.pageNumber!) {
              this.requestModel.pageNumber = 1;
            }

            this.data = new PCTableInputModel(
              result.data?.items,
              [
                {
                  name: 'Payment',
                  className: 'btn-outline-primary',
                  icon: 'fa-solid fa-credit-card',
                },
                {
                  name: 'Delete',
                  className: 'btn-outline-danger',
                  icon: 'bx bx-trash',
                },
              ],
              true,
              firstItemOnPage,
              this.requestModel.orderBy,
              this.requestModel.direction
            );

            this.paging = this.responseService.customizePaging(result);
          } else {
            this.logger.addBackEndMessage(result);
          }
        },
        (error) => {
          this.apiService.AddErrorLog(error);
        },
        () => {
          this.loading = false;
        }
      );
    } catch (e) {
      this.logger.addException(e, true);
    }
  }

  public getData() {
    return this.apiService.getAll(new ApiRequestModel(this.endPointUrl)).pipe(
      catchError((error) => {
        this.apiService.AddErrorLog(error);
        this.loading = false;
        return of(null);
      })
    );
  }

  public getEntity() {
    return this.apiService
      .getEntity(
        new ApiRequestModel(
          'SaleFactor',
          null,
          undefined,
          'SaleFactor',
          'CashDesk'
        )
      )
      .pipe(
        catchError((error) => {
          this.apiService.AddErrorLog(error);
          return of(null);
        })
      );
  }

  public generateUrl() {
    this.endPointUrl = `SaleFactor/CashDesk?pageNumber=${this.requestModel.pageNumber}&pageSize=${this.requestModel.pageSize}&paging=${this.requestModel.paging}&orderBy=${this.requestModel.orderBy}&direction=${this.requestModel.direction}&search=${this.requestModel.search}`;
  }

  public parentAction(event: PCTableOutputModel) {
    switch (event.action) {
      case 'Sort':
        this.loading = true;
        if (this.requestModel.orderBy == '') {
          this.requestModel.direction = 'asd';
        } else if (this.requestModel.orderBy != event.data) {
          this.requestModel.direction = 'asd';
        } else if (this.requestModel.direction == '') {
          this.requestModel.direction = 'asd';
        } else if (this.requestModel.direction == 'asd') {
          this.requestModel.direction = 'desc';
        }

        this.requestModel.orderBy = event.data;

        this.getSingleData;
        break;
      case 'Payment':
        this.factorList = [];
        this.factorList.push(event.data);
        this.finalPayment = event.data.totalPrice;
        this.paymentOpenModal();

        setTimeout(() => {
          this.setFocus();
        }, 1000);

        break;

      case 'Reload':
        this.loading = true;
        this.requestModel.pageNumber = 1;
        this.getSingleData;
        break;

      case 'Search':
        this.loading = true;
        this.requestModel.pageNumber = 1;
        this.requestModel.search = event.data;
        this.getSingleData;
        break;

      case 'Delete':
        this.modalDeleteConfirm = true;
        this.thisValue = event.data;
        this.openModal();
        break;

      case 'Paging':
        this.loading = true;

        this.requestModel.pageNumber = event.data;
        this.getSingleData;
        break;

      case 'PageSize':
        this.loading = true;
        this.requestModel.pageNumber = 1;
        this.requestModel.pageSize = event.data;
        this.getSingleData;
        break;

      case 'FastSale':
        this.loading = true;
        this.goToFastSale();
        break;

      case 'credit':
        // this.loading = true;
        this.OpenClearModal();
        break;
      case 'Settings':
        this.pcsettingModalComponent.openSettingModal();
        break;
      case 'SubmitSetting':
        this.fields = event.data;
        if (this.pcTableComponent) {
          this.pcTableComponent.RebuildColumn();
        } else {
          console.error('PCTableComponent not found');
        }
        break;
      default:
        break;
    }
  }

  public addNewItem() {
    try {
      if (this.scannedBarcode == ``) {
        this.setScannerLog(`بارکد ناخوانا است`);
        this.scannerCompleted = false;
        return;
      }

      let thisUrl = `CashDesk/CashDesk?search=Barcode:${this.scannedBarcode}`;
      if (!this.apiService.tokenValidation(new ApiRequestModel(thisUrl))) {
        return;
      }

      var foundedDuplicate = this.factorList.filter(
        (current) => current.barcod == this.scannedBarcode
      );

      if (foundedDuplicate.length > 0) {
        this.setScannerLog(`بارکد تکراری است `);
        this.scannerCompleted = false;
        return;
      }

      this.newBarcodLoading = true;
      this.apiService.getAll(new ApiRequestModel(thisUrl)).subscribe(
        (result) => {
          this.logger.addResponseLog(thisUrl, result, `Get All`);
          if (result.succeeded) {
            if (result.data?.count == 0) {
              this.setScannerLog(`بارکد در پایگاه داده یافت نشد`);
              this.scannerCompleted = false;
              return;
            } else {
              const thisElement = result.data?.items[0];

              if (thisElement.isPaid) {
                this.setScannerLog(`فاکتور قبلا پرداخت شده است`);
                this.scannerCompleted = false;
                return;
              } else {
                this.factorList.push(result.data?.items[0]);
                this.finalPayment += result.data?.items[0].totalPrice;
                this.setScannerLog(`به لیست پرداختی ها اضافه شد`);
                this.scannerCompleted = true;
              }
            }
          } else {
            this.logger.addBackEndMessage(result);
          }
        },
        (error) => {
          this.apiService.AddErrorLog(error);
        },
        () => {
          this.scannedBarcode = ``;
          this.newBarcodLoading = false;
        }
      );
    } catch (e) {
      this.logger.addException(e, true);
    }
  }

  public OpenClearModal() {
    this.factorList = [];
    this.paymentOpenModal();
    this.setFocus();
  }
  public setScannerLog(message: string) {
    this.scannedBarcode = ``;
    this.scannerLog = message;
    setTimeout(() => {
      this.scannerLog = ``;
    }, 1 * 1000);
  }

  public setFocus() {
    let inputBarcod = document.getElementById('barcodScanner');
    if (!inputBarcod) {
      this.logger.addError('Have Problem Please ReOpen Modal', false);
      return;
    }

    inputBarcod.focus();
  }

  // public confirmPayment(isCash: boolean) {
  //   this.newBarcodLoading = true;

  //   try {
  //     let thisUrl = `CashDesk/PaymentList`;
  //     this.apiService
  //       .postItem(new ApiRequestModel(thisUrl, this.factorList))
  //       .subscribe(
  //         (result) => {
  //           this.logger.addResponseLog(thisUrl, result, `Get All`);
  //           if (result.succeeded) {
  //             this.modalService.dismissAll();
  //             this.getSingleData;
  //             setTimeout(() => {
  //               let backgroundFocus = document.getElementById('focustest');
  //               backgroundFocus?.focus();
  //             }, 1 * 1000);
  //           } else {
  //             this.logger.addBackEndMessage(result);
  //             this.newBarcodLoading = false;
  //           }
  //         },
  //         (error) => {
  //           this.apiService.AddErrorLog(error);
  //           this.newBarcodLoading = false;
  //         },
  //         () => {
  //           this.scannedBarcode = ``;
  //           this.newBarcodLoading = false;
  //         }
  //       );
  //   } catch (e) {
  //     this.logger.addException(e, false);
  //   }
  // }

  public paymentOpenModal() {
    try {
      if (this.paymentModalIsOpen) {
        return;
      }
      this.paymentModalIsOpen = !this.paymentModalIsOpen;
      this.modalService
        .open(this.creditElemnt, { ariaLabelledBy: 'modal-basic-title' })
        .result.then(
          (result) => {
            this.scannedBarcode = ``;
            this.finalPayment = 0;
            this.paymentModalIsOpen = false;
            setTimeout(() => {
              var item = document.getElementById('focustest');
              item?.focus();
            }, 200);
          },
          (reason) => {
            this.scannedBarcode = ``;
            this.finalPayment = 0;
            this.paymentModalIsOpen = false;
            setTimeout(() => {
              var item = document.getElementById('focustest');
              item?.focus();
            }, 200);
          }
        );
    } catch (error) {
      this.logger.addException(error, true);
    }
  }

  public openModal() {
    try {
      this.modalService
        .open(this.modalContent, { ariaLabelledBy: 'modal-basic-title' })
        .result.then(
          (result) => {},
          (reason) => {}
        );
    } catch (error) {
      this.logger.addException(error, false);
    }
  }

  public submitDelete() {
    try {
      this.loading = true;
      let url = `SaleFactor/ReturnFactor`;

      const backEndJson = {
        taminToken: null,
        slamatToken: null,
        saleFactorId: this.thisValue.id,
        detailIds: [],
      };

      this.apiService.postItem(new ApiRequestModel(url, backEndJson)).subscribe(
        (result) => {
          if (result.succeeded) {
            this.modalSuccessConfirm = true;
            this.modalService.dismissAll();
            this.getSingleData;
          } else {
            this.logger.addBackEndMessage(result);
          }
        },
        (error) => {
          this.apiService.AddErrorLog(error);
        },
        () => {}
      );
    } catch (e) {
      this.logger.addException(e, false);
    }
  }

  public deleteFactorList(item: any) {
    this.factorList = this.factorList.filter(
      (current) => current.id != item.id
    );

    this.finalPayment -= item.totalPrice;
  }

  public goToFastSale() {
    this.router.navigate(['fastSale']);
  }
}
